export default __webpack_public_path__ + "static/study-image03-8c6d66f23a078d4094f87146d0e84dfa.jpg";